import React from 'react';
import PropTypes from 'prop-types';

class SearchResults extends React.Component {
  static propTypes = {
    excludedItems: PropTypes.array.isRequired,
    items: PropTypes.array.isRequired,
    query: PropTypes.string.isRequired,
    renderItem: PropTypes.func.isRequired,
    searching: PropTypes.bool,

    onSelect: PropTypes.func.isRequired
  }

  handleSelect = (event) => {
    const item = this.props.items.find(item => item.id === parseInt(event.currentTarget.dataset.id));
    this.props.onSelect(item);
  }

  render() {
    return (
      <div className="search-results-dropdown">
        <div className="search-results">
          <ul className="list-group search-results-list">
            {this.props.searching ? this.renderProgress() : this.renderResults()}
          </ul>
        </div>
      </div>
    );
  }

  renderProgress() {
    return (
      <li className="list-group-item">
        <strong>Searching...</strong>
      </li>
    );
  }

  renderResults() {
    const { excludedItems, items, query } = this.props;
    const excludedIds = excludedItems.map(item => item.id);
    const includedItems = items.filter(item => excludedIds.indexOf(item.id) === -1);

    if (includedItems.length === 0) {
      return (
        <li className="list-group-item">
          <strong>No results for "{query}"</strong>
        </li>
      );
    }

    return includedItems.map((item, i) => (
      <li
        className="list-group-item"
        data-id={item.id}
        key={i}
        onMouseDown={this.handleSelect}
      >
        {this.props.renderItem(item)}
      </li>
    ));
  }
}

export default SearchResults;
